import { render } from "./RawMaterialPurchase.vue?vue&type=template&id=1bcff1e2"
import script from "./RawMaterialPurchase.vue?vue&type=script&lang=js"
export * from "./RawMaterialPurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__